import React from 'react';
import { useTranslation } from 'react-i18next';
import { TodoList } from '@unmind/design-system';
import { useUserEntitlements } from 'hooks/useUserEntitlements';
import useFeatureFlag, { FEATURE_FLAGS } from 'flags/useFeatureFlag';
import DailyBoostItem from './DailyBoostItem';
import { TherapyAndCoachingItem } from './TherapyAndCoachingItem';
import { ChatItem } from './ChatItem';
import { SkeletonItem } from './SkeletonItem';
import { WellbeingMeasureItem } from './WellbeingMeasureItem';
import { SupportFinderItem } from './SupportFinderItem';

export const HomepageTodoList = () => {
  const { t: translate } = useTranslation('homepage', {
    keyPrefix: 'todo_list_section',
  });

  const isSupportFinderItemEnabled = useFeatureFlag(
    FEATURE_FLAGS.SUPPORT_FINDER_TODOLIST_ITEM_ENABLED,
  );

  const {
    entitlements,
    loading: isEntitlementsLoading,
    error: entitlementsError,
  } = useUserEntitlements();

  if (isEntitlementsLoading) {
    return (
      <section>
        <h2 className="title-s section-title" id="todo-list-title">
          {translate('title')}
        </h2>

        <TodoList
          aria-labelledby="todo-list-title"
          aria-busy="true"
          data-testid="homepage-todo-list-skeleton"
          completedScreenreaderText=""
        >
          <SkeletonItem />
          <SkeletonItem />
          <SkeletonItem />
        </TodoList>
      </section>
    );
  }

  if (entitlementsError || !entitlements) {
    return null;
  }

  return (
    <section>
      <h2 className="title-s section-title" id="todo-list-title">
        {translate('title')}
      </h2>
      <TodoList
        aria-labelledby="todo-list-title"
        data-testid="homepage-todo-list"
        completedScreenreaderText={translate('completed_label')}
      >
        {isSupportFinderItemEnabled && <SupportFinderItem />}
        {entitlements.nova && <ChatItem />}
        <DailyBoostItem />
        {entitlements.unmindTalk && <TherapyAndCoachingItem />}
        <WellbeingMeasureItem />
      </TodoList>
    </section>
  );
};
